import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilterStore,
  reportFilterCountryCodeSelector,
  reportFilterStoresSelector,
  reportOpStructuresFilterAgreementSelector,
  reportOpStructuresFilterCompanySelector,
  reportOpStructuresFilterManagementSelector,
  reportOpStructuresFilterRegionalManagementSelector,
  reportOpStructuresFilterRegionSelector,
  reportOpStructuresFilterSupervisionSelector,
} from '../../../state';
import { Stores } from '../../../types';
import { StoreSelect } from '../../selects';

const StoreFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const countryCode = useSelector(reportFilterCountryCodeSelector);
  const storesSelected = useSelector(reportFilterStoresSelector);
  const regionalManagement = useSelector(reportOpStructuresFilterRegionalManagementSelector);
  const regions = useSelector(reportOpStructuresFilterRegionSelector);
  const managements = useSelector(reportOpStructuresFilterManagementSelector);
  const supervisions = useSelector(reportOpStructuresFilterSupervisionSelector);
  const agreements = useSelector(reportOpStructuresFilterAgreementSelector);
  const companies = useSelector(reportOpStructuresFilterCompanySelector);

  const handleChange = useCallback(
    (value: Stores[]) => dispatch(changeFilterStore(value)),
    [dispatch]
  );

  useEffect(() => {
    const hasAnyOpStructureFilter =
      regionalManagement.length > 0 ||
      regions.length > 0 ||
      managements.length > 0 ||
      supervisions.length > 0 ||
      agreements.length > 0 ||
      companies.length > 0;

    if (hasAnyOpStructureFilter && storesSelected.length > 0) {
      dispatch(changeFilterStore([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    regionalManagement,
    regions,
    managements,
    supervisions,
    agreements,
    companies,
    dispatch,
    // Excluyo storesSelected.length para evitar loop infinito
  ]);

  return (
    <StoreSelect
      label={t('toolbar.labels.store')}
      limitTags={3}
      countryCode={countryCode}
      value={storesSelected}
      onChange={handleChange}
      regionalManagements={regionalManagement}
      regions={regions}
      managements={managements}
      supervisions={supervisions}
      agreements={agreements}
      companies={companies}
      selectAll
    />
  );
};

export default StoreFilter;
